// test2221
(2221 && 0);
